var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('update-alert'),_c('router-view'),(_vm.showChat)?_c('chat-incoming-popup'):_vm._e(),(_vm.showChat)?_c('chat-composer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }